import { render, staticRenderFns } from "./factory_us.vue?vue&type=template&id=fb48023e"
import script from "./factory_us.vue?vue&type=script&lang=js"
export * from "./factory_us.vue?vue&type=script&lang=js"
import style0 from "./factory_us.vue?vue&type=style&index=0&id=fb48023e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports